import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import ProtectedRoute from "./components/Dashboard/ProtectedRoute";
import Home from "./pages/home/Home";
import Solutions from "./pages/solutions/Solutions";
import Industries from "./pages/industries/Industries";
import Technology from "./pages/technology/Technology";
import Partners from "./pages/partners/Partners";
import Contact from "./pages/contact/Contact";
import Developers from "./pages/developers/Developers";
import TermsAndConditions from "./pages/terms/TermsAndConditions";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import ApiDocumentation from "./pages/documentation/ApiDocumentation";
import Login from "./pages/login/Login";
import ResetPassword from "./pages/reset-password/ResetPassword";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import SetPassword from "./pages/set-password/SetPassword";
import Overview from "./pages/overview/Overview";
import Esims from "./pages/esims/Esims";
import Orders from "./pages/orders/Orders";
import Customers from "./pages/customers/Customers";
import Settings from "./pages/settings/Settings";
import Appointments from "./pages/appointments/Appointments";
import Contacts from "./pages/contacts/Contacts";
import Partnership from "./pages/partnership/Partnership";
import { getDashboardHomePath } from "./utils/auth";

function DashboardHome() {
  const homePath = getDashboardHomePath();
  if (homePath !== "/dashboard") {
    return <Navigate to={homePath} replace />;
  }
  return <Overview />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="set-password" element={<SetPassword />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="esims" element={<Esims />} />
          <Route path="orders" element={<Orders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="settings" element={<Settings />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="partnership" element={<Partnership />} />
          <Route path="contact" element={<Contacts />} />
          <Route path="documentation" element={<ApiDocumentation />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="solutions" element={<Solutions />} />
          <Route path="industries" element={<Industries />} />
          <Route path="technology" element={<Technology />} />
          <Route path="partners" element={<Partners />} />
          <Route path="contact" element={<Contact />} />
          <Route path="developers" element={<Developers />} />
          <Route path="api" element={<Navigate to="/developers" replace />} />
          <Route path="terms" element={<TermsAndConditions />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route
            path="documentation"
            element={<ApiDocumentation variant="public" />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
